(function () {
  var input = document.getElementById('help-search-input');
  var results = document.getElementById('help-search-results');
  var categoriesEl = document.getElementById('help-index-categories');
  if (!input || !results) return;

  var miniSearch = null;
  var dataLoaded = false;
  var pendingQuery = null;

  function loadData() {
    if (dataLoaded || !window.helpSearchDataUrl) return;
    fetch(window.helpSearchDataUrl, { credentials: 'same-origin' })
      .then(function (res) { return res.text(); })
      .then(function (text) {
        var docs;
        try {
          docs = JSON.parse(text);
        } catch (e) {
          docs = [];
        }

        miniSearch = new MiniSearch({
          fields: ['title', 'summary', 'category', 'variants'],
          storeFields: ['title', 'summary', 'category', 'url'],
          extractField: function (doc, fieldName) {
            if (fieldName === 'variants' && Array.isArray(doc.variants)) {
              return doc.variants.join(' ');
            }
            return doc[fieldName];
          },
          searchOptions: { prefix: true, fuzzy: 0.2, boost: { title: 2 } }
        });
        miniSearch.addAll(docs);
        dataLoaded = true;

        if (pendingQuery !== null) {
          runSearch(pendingQuery);
          pendingQuery = null;
        }
      })
      .catch(function () {
        dataLoaded = false;
      });
  }

  function renderResults(hits, query) {
    if (!query) {
      results.hidden = true;
      results.innerHTML = '';
      if (categoriesEl) categoriesEl.hidden = false;
      return;
    }

    if (categoriesEl) categoriesEl.hidden = true;
    results.hidden = false;

    if (!hits.length) {
      results.innerHTML = '<p class="help-search__empty">No articles matched &ldquo;' + escapeHtml(query) + '&rdquo;.</p>';
      return;
    }

    var html = '<ul class="help-search__result-list">';
    hits.slice(0, 20).forEach(function (hit) {
      html += '<li class="help-search__result">' +
        '<a href="' + hit.url + '">' +
          '<span class="help-search__result-title">' + escapeHtml(hit.title) + '</span>' +
          (hit.summary ? '<span class="help-search__result-summary">' + escapeHtml(hit.summary) + '</span>' : '') +
          (hit.category ? '<span class="help-search__result-category">' + escapeHtml(hit.category) + '</span>' : '') +
        '</a>' +
      '</li>';
    });
    html += '</ul>';
    results.innerHTML = html;
  }

  function escapeHtml(str) {
    return String(str || '').replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function runSearch(query) {
    if (!miniSearch) {
      pendingQuery = query;
      loadData();
      return;
    }
    var hits = query ? miniSearch.search(query) : [];
    renderResults(hits, query);
  }

  var debounceTimer;
  input.addEventListener('input', function () {
    clearTimeout(debounceTimer);
    var query = input.value.trim();
    debounceTimer = setTimeout(function () { runSearch(query); }, 120);
  });

  input.addEventListener('focus', loadData, { once: true });
})();
